import { Language } from '../types';

export const TRANSLATIONS = {
  nl: {
    // App Branding & Meta

    // Targets
    targetTitle: 'Wat wil je berekenen?',
    targetTime: 'Tijd',
    targetPace: 'Pace',
    targetDistance: 'Afstand',

    // Hero Banner & Results
    calculatedTime: 'Berekende Tijd',
    calculatedPace: 'Berekend Tempo',
    calculatedSpeed: 'Berekende Snelheid',
    calculatedDistance: 'Berekende Afstand',
    saveToLogbook: 'Sla op in Logboek',
    shareCalculation: 'Deel berekening',
    resetDefaultsDesc: 'Herstel standaardwaarden (10k @ 5:00/km)',
    saveSuccessLogbook: 'Opgeslagen in Logboek!',
    valuesLoadedToast: 'Waarden geladen in calculator',
    updateAvailable: 'Nieuwe versie beschikbaar',
    updateNow: 'Vernieuwen',
    updateLater: 'Later',
    sharePreviewTitle: 'Gedeelde berekening',
    sharePreviewDesc: 'Iemand deelde deze waarden met je. Overnemen in de calculator?',
    shareAccept: 'Overnemen',
    shareIgnore: 'Negeren',
    shareLoadedToast: 'Berekening geladen via gedeelde link',
    shareInvalidToast: 'Deze link is ongeldig of beschadigd',
    metaTitle: 'PaceFlow | Hardloop Pace Calculator, Doeltijd & Splits Berekenen',
    metaDescription: 'Bereken direct je hardlooptempo (pace per km/mijl), doeltijd en afstanden. Inclusief negatieve split-calculators en offline running log. Gratis en zonder ads.',
    backOnlineToast: '🟢 Weer online',
    analyticsTitle: 'Anonieme statistieken',
    analyticsAsk: 'Mag ik anoniem bijhouden hoe de app gebruikt wordt (bezoeken en duur)? Zo kan ik hem verbeteren.',
    analyticsDesc: 'Anoniem bezoek en gebruiksduur, om de app te verbeteren. Je gegevens in de app blijven op je toestel.',
    analyticsAllow: 'Toestaan',
    analyticsDeny: 'Niet nu',
    analyticsOn: 'Statistieken aan',
    analyticsOff: 'Statistieken uit',
    offlineBanner: 'Offline modus • Lokale data behouden',
    calculatedFrom: 'obv',
    statTotalDistance: 'Afstand',
    statRunsLogged: 'runs gelogd',
    searchPlaceholder: 'Zoek in opgeslagen runs...',
    manualBtn: 'Handmatig',
    noRunsFound: 'Nog geen opgeslagen hardloopsessies',
    noRunsFoundDesc: 'Gebruik de Pace Calculator en klik op "Sla op in Logboek" of voeg direct een training toe.',
    loadInCalc: 'Open in calculator',
    metricDistance: 'Afstand',
    metricTime: 'Tijd',
    metricSpeed: 'Snelheid',
    addRunTitle: 'Voeg Training Toe',
    formTitle: 'Titel / Beschrijving',
    formDistanceKm: 'Afstand (km)',
    formFeeling: 'Gevoel',
    formTime: 'Totale Tijd (Uren : Minuten : Seconden)',
    formNotes: 'Notities (optioneel)',
    formNotesPlaceholder: 'Hoe ging de training? Schoenen, weer, hartslag...',
    saveLogBtn: 'Opslaan in Logboek',

    // Card Titles & Subtitles
    distanceCardTitle: 'Afstand',
    speedCardTitle: 'Snelheid',
    timeCardTitle: 'Tijd',

    // Units & Labels
    hours: 'Uur',
    minutes: 'Minuten',
    seconds: 'Seconden',
    meters: 'Meters',
    unitKm: 'km',
    unitMi: 'mi',
    unitM: 'm',
    unitH: 'u',
    unitMin: 'min',
    unitSec: 'sec',
    unitDecimals: 'decimalen',
    unitFt: 'ft',

    // Presets

    // Insights & Zones

    // Predictions

    // Header & Tooltips
    splitsTooltip: 'Splits & Racestrategie',
    logbookTooltip: 'Hardlooplogboek',
    settingsTooltip: 'Instellingen',

    // Splits Modal & View
    splitsTitleKm: 'Kilometer Splits & Strategie',
    splitsTitleMi: 'Mijl Splits & Strategie',
    splitsSubtitle: 'Tussentijden en racestrategie voor',
    stratEven: 'Even Pace',
    stratEvenDesc: 'Gelijkmatig tempo',
    stratNeg2: 'Negative 2%',
    stratNeg2Desc: 'Aanbevolen (2e helft sneller)',
    stratNeg5: 'Negative 5%',
    stratNeg5Desc: 'Sterke eindsprint',
    stratPos3: 'Positieve split (+3%)',
    stratPos3Desc: 'Snelle start',
    colDistance: 'Afstand',
    colSplitTime: 'Split Tijd',
    colCumulative: 'Cumulatief (Doortijd)',
    colPace: 'Pace',
    copySplits: 'Kopieer lijst',
    copiedSplits: 'Gekopieerd!',
    splitsCount: 'splits',

    // Logbook Modal & View
    logbookTitle: 'Mijn Hardlooplogboek',
    savedRunsCount: 'opgeslagen trainingen',
    savedRunSingle: 'opgeslagen training',
    statAvgPace: 'Gem. Tempo',
    statTotalTime: 'Totale Tijd',
    exportJson: 'Exporteer JSON',
    importJson: 'Importeer JSON',
    deleteRun: 'Verwijderen',
    cancelBtn: 'Annuleren',

    // Settings Modal
    settingsTitle: 'Instellingen',
    settingsDesc: 'Taal, thema, weergave en installatie',
    languageLabel: 'Taal',
    nightModeLabel: 'Weergave',
    modeLight: 'Licht',
    modeDark: 'Donker',
    modeAuto: 'Automatisch',
    autoDesc: 'Volgt de systeemvoorkeur of schakelt automatisch tussen 20:00 en 07:00 naar donker.',
    darkDesc: 'Altijd donkere nachtweergave voor contrast & batterijbesparing.',
    lightDesc: 'Altijd heldere lichte weergave.',
    distanceUnitLabel: 'Afstandseenheid',
    unitKmFull: 'Kilometers (km)',
    unitMiFull: 'Mijlen (mi)',
    paceSpeedLabel: 'Pace / Snelheid Voorkeur',
    prefPace: 'Pace (min/km of min/mi)',
    prefSpeed: 'Snelheid (km/u of mph)',
    accentColorLabel: 'Accentkleur',
    shareAppDesc: 'Deel deze hardloopcalculator met hardloopvrienden of een loopgroep.',
    shareAppBtn: 'Deel PaceFlow app',
    shareAppCopied: 'Link naar PaceFlow gekopieerd!',

    // Install Modal
    installModalTitle: 'Voeg toe aan beginscherm',
    installModalSubtitle: 'Installeer PaceFlow als native app',
    benefitFast: '⚡ Snel',
    benefitFastDesc: '1-klik toegang',
    benefitOffline: '📶 Offline',
    benefitOfflineDesc: 'Werkt overal',
    benefitStorage: '💾 Lokaal',
    benefitStorageDesc: 'Veilig bewaard',
    installNowBtn: 'Installeer nu direct',
    closeBtn: 'Sluiten',

    // Onboarding / Welcome Modal
    onboardingTitle: 'Welkom bij PaceFlow',
    onboardingSubtitle: 'Stel jouw hardloopvoorkeuren in',
    onboardingNotice: 'Je kunt deze instellingen op elk moment wijzigen via het tandwiel-icoon rechtsboven.',
    onboardingStartBtn: 'Aan de slag',
    onboardingStepUnits: 'Kies je standaard eenheid',
    onboardingStepPaceOrSpeed: 'Standaard weergave (Pace vs Snelheid)',
    onboardingStepLanguage: 'Kies je taal',
    onboardingStepTheme: 'Kies je weergave',
    // Voorheen inline in componenten
    uiCalculateTime: 'Tijd Berekenen',
    uiCalculateSpeed: 'Snelheid Berekenen',
    uiCalculatePace: 'Pace Berekenen',
    uiSpeed: 'Snelheid',
    uiCalculateDistance: 'Afstand Berekenen',
    uiFollowTheInstructionsBelow: 'Volg de instructies hieronder',
    uiInstructionsForIphoneIpad: '🍎 Instructies voor iPhone & iPad',
    uiInstructionsForAndroidDesktop: '🤖 Instructies voor Android & Desktop',
    uiTapTheShareIconAt: 'Tik onderaan in Safari op het Deel-icoon',
    uiScrollDownInTheMenu: 'Scroll in het menu omlaag en tik op \'Zet op beginscherm\'',
    uiTapAddInTheTop: 'Tik rechtsboven op \'Voeg toe\'. PaceFlow verschijnt direct op je startscherm!',
    uiTapTheBrowserMenuThe: 'Tik rechtsboven op het browsermenu (de 3 puntjes ⋮) in Chrome of Edge.',
    uiChooseInstallAppOrAdd: 'Kies \'App installeren\' of \'Toevoegen aan startscherm\'.',
    uiConfirmInstallationAndLaunchPaceflow: 'Bevestig de installatie en open PaceFlow voortaan direct vanaf je beginscherm.',
    uiMorningRun: 'Ochtendloop',
    uiRunningSession: 'Hardloop Training',
    uiVeryTough: 'Heel zwaar',
    uiFair: 'Matig',
    uiGood: 'Goed',
    uiGreat: 'Super',
    uiPersonalRecord: 'Persoonlijk Record',
    uiHrsMinSec: 'uur:min:sec',
    uiKmH: 'km/u',
    uiHrs: 'Uur',
    uiMin: 'Min',
    uiSec: 'Sec',
    uiValidLogbookImported: 'Geldig logboek geïmporteerd',
    uiMergeWithExistingRuns: 'Samenvoegen met huidige gegevens',
    uiOverwriteAllExistingRuns: 'Bestaande gegevens overschrijven',
    uiRun: 'Training',
    uiPaceflowRunningPaceCalculation: 'PaceFlow - Hardloop Pace Berekening',
    uiPaceflowInstalled: 'PaceFlow geïnstalleerd',
    uiRunningFromYourHomeScreen: 'Geopend vanaf je startscherm. Werkt 100% offline.',
    uiInstallPaceflow: 'PaceFlow Installeren',
    uiAddToHomeScreenFor: 'Voeg toe aan je beginscherm voor 1-klik toegang en direct offline gebruik.',
    uiAddToHomeScreen: 'Voeg toe aan beginscherm',
    uiIosSafariTap: 'iOS Safari: Tik op ',
    uiShare: '‘Delen’',
    uiAddToHomeScreen2: '‘Zet op beginscherm’',
    uiEnglish: 'Nederlands',
    uiKilometersKm: 'Kilometer (km)',
    uiMilesMi: 'Mijl (mi)',
    uiTotal: 'Totaal',
    uiKilometer: 'Kilometer',
    uiSplitTimes: 'Tussentijden',
    uiTargetTimeBasedOnDistance: 'Doeltijd o.b.v. afstand & tempo',
    uiHrMinSec: 'uur : min : sec',
    uiTxt: 'met',
    uiRequiredPaceBasedOnDistance: 'Benodigd tempo o.b.v. afstand & tijd',
    uiIn: 'in',
    uiDistanceBasedOnTimePace: 'Afstand o.b.v. tijd & tempo',
    importSchemaError: 'Het JSON-bestand voldoet niet aan het geldige PaceFlow logboek schema.',
    importInvalidJson: 'Ongeldig JSON-bestand. Controleer de bestandsstructuur.',
    importFound: '{count} trainingen gevonden in JSON-bestand.',
    importChoice: 'Wil je deze gegevens toevoegen aan je huidige logboek of alle bestaande trainingen overschrijven?',
    pwaBrowserSupport: 'Werkt in Chrome, Edge & Safari • 100% offline',
    shareRunText: '🏃 PaceFlow Hardloop Pace: {distance} {distanceUnit} in {time} (Pace: {pace}{paceUnit}, {speed} {speedUnit})',
    shareAppText: '🏃 PaceFlow – Find Your Pace, Perfect Your Flow.\nBereken direct je hardlooptempo, doeltijd en splits! 100% gratis en offline.',
    stratCustom: 'Eigen',
    printBand: 'Print polsbandje',
    stratCustomDesc: 'Kies zelf hoeveel sneller je tweede helft wordt.',
    customPctLabel: 'Negatieve split: {pct}% sneller aan het einde',
    slowStartLabel: 'Rustige eerste split',
    slowStartOff: 'Uit',
    perfOpenTitle: 'Voorspellingen & trainingszones',
    perfOpenDesc: 'Zie wat je op andere afstanden kunt lopen en in welk tempo je moet trainen.',
    perfTitle: 'Prestaties',
    perfSubtitle: 'Voorspellingen en trainingstempo\'s',
    perfTabPredict: 'Voorspelling',
    perfTabZones: 'Trainingszones',
    perfTabTools: 'Hulpmiddelen',
    perfReference: 'Gebaseerd op',
    perfRefCurrent: 'Huidige berekening',
    perfRefBest: 'Beste uit logboek',
    perfRefNone: 'Sla een run op in je logboek om die als referentie te kunnen kiezen.',
    perfIn: 'in',
    perfVdot: 'Vormindex (VDOT)',
    perfTooShort: 'Kies een afstand en tijd van minstens 3 minuten en hoogstens 8 uur.',
    perfPredictNote: 'Schatting volgens Riegel. Hoe verder een afstand van je referentie ligt, hoe onzekerder de schatting.',
    race10Miles: '10 mijl',
    raceHalf: 'Halve marathon',
    raceMarathon: 'Marathon',
    zoneEasy: 'Rustig',
    zoneEasyDesc: 'Duurlopen, herstel en opbouw',
    zoneMarathon: 'Marathon',
    zoneMarathonDesc: 'Je tempo op marathonrace-dag',
    zoneNameThreshold: 'Drempel',
    zoneThresholdDesc: 'Comfortabel zwaar, tempoduurloop',
    zoneNameInterval: 'Interval',
    zoneIntervalDesc: 'Zwaar, blokken van 3 tot 5 minuten',
    zoneRepetition: 'Herhaling',
    zoneRepetitionDesc: 'Snel en kort, met ruime rust',
    zonesNote: 'Trainingstempo\'s volgens Daniels, berekend uit je vormindex.',
    toolsWeather: 'Weer',
    toolsWeatherDesc: 'Warmte maakt je trager. Zo pas je je tempo daarop aan.',
    toolsTemp: 'Temperatuur (°C)',
    toolsHumidity: 'Luchtvochtigheid (%)',
    toolsAdjusted: 'Aangepast tempo',
    toolsSlowdown: 'Ongeveer {pct}% trager',
    toolsNoSlowdown: 'Geen aanpassing nodig',
    toolsTreadmill: 'Loopband',
    toolsTreadmillDesc: 'Zet de snelheid op de band om naar tempo.',
    toolsSpeed: 'Snelheid',
    toolsCurrentPaceIs: 'Je huidige tempo is',
    toolsTrack: 'Baan',
    toolsTrackDesc: 'Tijden per afstand bij je huidige tempo.',
    insightsTitle: 'Jouw voortgang',
    insightStreak: 'Weken op rij',
    insightStreakUnit: 'weken',
    insightTrend: 'Tempotrend',
    insightTrendFaster: '{sec} s/km sneller',
    insightTrendSlower: '{sec} s/km trager',
    insightTrendSame: 'Gelijk gebleven',
    insightTrendNeed: 'Vanaf 6 runs zichtbaar',
    insightWeekly: 'Kilometers per week',
    insightWeeklyLast12: 'De laatste 12 weken',
    insightNow: 'Nu',
    weekOf: 'Week van {date}',
    insightRecords: 'Persoonlijke records',
    insightRecordsNone: 'Loop een standaardafstand, zoals 5 of 10 km, om een record te zetten.',
    insightFeeling: 'Gevoel en tempo',
    insightFeelingDesc: 'Gemiddeld tempo per gevoel',
    goalTitle: 'Racedoel',
    goalEmpty: 'Stel een doel in om af te tellen en te zien of je op schema ligt.',
    goalSet: 'Doel instellen',
    goalEdit: 'Doel wijzigen',
    goalDelete: 'Doel verwijderen',
    goalRace: 'Afstand',
    goalTargetTime: 'Doeltijd',
    goalDate: 'Racedag',
    goalSave: 'Opslaan',
    goalInvalid: 'Controleer de afstand, doeltijd en racedag.',
    goalDaysLeft: 'Nog {days} dagen',
    goalOneDay: 'Nog 1 dag',
    goalToday: 'Vandaag is de racedag',
    goalPast: 'De racedag is voorbij',
    goalRequiredPace: 'Benodigd tempo',
    goalPredicted: 'Voorspeld vanaf je beste run',
    goalStatusAhead: 'Voor op schema',
    goalStatusOn: 'Op schema',
    goalStatusBehind: 'Nog {time} te traag',
    goalStatusUnknown: 'Sla een run op om te zien of je op schema ligt',
    editRunTitle: 'Run bewerken',
    editRunBtn: 'Bewerken',
    formDate: 'Datum',
    exportCsv: 'Exporteer als CSV',
    runDeletedToast: 'Run verwijderd',
    runRestoredToast: 'Run teruggezet',
    runUpdatedToast: 'Run bijgewerkt',
    undoBtn: 'Ongedaan maken',
    recordBadge: 'Record {distance}',
    newRecordToast: 'Nieuw record op de {distance}!',
  },
  en: {
    // App Branding & Meta

    // Targets
    targetTitle: 'What do you want to calculate?',
    targetTime: 'Time',
    targetPace: 'Pace',
    targetDistance: 'Distance',

    // Hero Banner & Results
    calculatedTime: 'Calculated Time',
    calculatedPace: 'Calculated Pace',
    calculatedSpeed: 'Calculated Speed',
    calculatedDistance: 'Calculated Distance',
    saveToLogbook: 'Save to Running Log',
    shareCalculation: 'Share Calculation',
    resetDefaultsDesc: 'Reset default values (10k @ 5:00/km)',
    saveSuccessLogbook: 'Saved to Running Log!',
    valuesLoadedToast: 'Values loaded into calculator',
    updateAvailable: 'New version available',
    updateNow: 'Refresh',
    updateLater: 'Later',
    sharePreviewTitle: 'Shared calculation',
    sharePreviewDesc: 'Someone shared these values with you. Load them into the calculator?',
    shareAccept: 'Load',
    shareIgnore: 'Ignore',
    shareLoadedToast: 'Calculation loaded from shared link',
    shareInvalidToast: 'This link is invalid or damaged',
    metaTitle: 'PaceFlow | Running Pace Calculator, Target Time & Splits',
    metaDescription: 'Instantly calculate your running pace (per km/mile), target time and distances. Includes negative split calculators and an offline running log. Free and ad-free.',
    backOnlineToast: '🟢 Back online',
    analyticsTitle: 'Anonymous statistics',
    analyticsAsk: 'May I anonymously track how the app is used (visits and duration)? It helps me improve it.',
    analyticsDesc: 'Anonymous visits and usage time, to improve the app. Your data in the app stays on your device.',
    analyticsAllow: 'Allow',
    analyticsDeny: 'Not now',
    analyticsOn: 'Statistics on',
    analyticsOff: 'Statistics off',
    offlineBanner: 'Offline mode • Local data active',
    calculatedFrom: 'Based on',
    statTotalDistance: 'Distance',
    statRunsLogged: 'runs logged',
    searchPlaceholder: 'Search saved runs...',
    manualBtn: 'Manual',
    noRunsFound: 'No saved running sessions yet',
    noRunsFoundDesc: 'Use the Pace Calculator and click "Save to Running Log" or add a run directly.',
    loadInCalc: 'Open in calculator',
    metricDistance: 'Distance',
    metricTime: 'Time',
    metricSpeed: 'Speed',
    addRunTitle: 'Add Running Session',
    formTitle: 'Title / Description',
    formDistanceKm: 'Distance (km)',
    formFeeling: 'Feeling',
    formTime: 'Total Time (Hours : Minutes : Seconds)',
    formNotes: 'Notes (optional)',
    formNotesPlaceholder: 'How did the run go? Shoes, weather, heart rate...',
    saveLogBtn: 'Save to Running Log',

    // Card Titles & Subtitles
    distanceCardTitle: 'Distance',
    speedCardTitle: 'Speed',
    timeCardTitle: 'Time',

    // Units & Labels
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meters: 'Meters',
    unitKm: 'km',
    unitMi: 'mi',
    unitM: 'm',
    unitH: 'h',
    unitMin: 'min',
    unitSec: 'sec',
    unitDecimals: 'decimals',
    unitFt: 'ft',

    // Presets

    // Insights & Zones

    // Predictions

    // Header & Tooltips
    splitsTooltip: 'Splits & Race Strategy',
    logbookTooltip: 'Running Log',
    settingsTooltip: 'Settings',

    // Splits Modal & View
    splitsTitleKm: 'Kilometer Splits & Strategy',
    splitsTitleMi: 'Mile Splits & Strategy',
    splitsSubtitle: 'Pacing splits and race strategy for',
    stratEven: 'Even Pace',
    stratEvenDesc: 'Steady even pace',
    stratNeg2: 'Negative 2%',
    stratNeg2Desc: 'Recommended (2nd half faster)',
    stratNeg5: 'Negative 5%',
    stratNeg5Desc: 'Strong final kick',
    stratPos3: 'Positive split (+3%)',
    stratPos3Desc: 'Fast start',
    colDistance: 'Distance',
    colSplitTime: 'Split Time',
    colCumulative: 'Cumulative (Elapsed)',
    colPace: 'Pace',
    copySplits: 'Copy list',
    copiedSplits: 'Copied!',
    splitsCount: 'splits',

    // Logbook Modal & View
    logbookTitle: 'Running Log',
    savedRunsCount: 'saved runs',
    savedRunSingle: 'saved run',
    statAvgPace: 'Avg. Pace',
    statTotalTime: 'Total Time',
    exportJson: 'Export JSON',
    importJson: 'Import JSON',
    deleteRun: 'Delete',
    cancelBtn: 'Cancel',

    // Settings Modal
    settingsTitle: 'Settings',
    settingsDesc: 'Language, theme, display & installation',
    languageLabel: 'Language',
    nightModeLabel: 'Display',
    modeLight: 'Light',
    modeDark: 'Dark',
    modeAuto: 'Auto',
    autoDesc: 'Follows system preference or automatically switches to dark mode between 20:00 and 07:00.',
    darkDesc: 'Always dark mode for high contrast & battery savings.',
    lightDesc: 'Always clean light display.',
    distanceUnitLabel: 'Distance Unit',
    unitKmFull: 'Kilometers (km)',
    unitMiFull: 'Miles (mi)',
    paceSpeedLabel: 'Pace / Speed Preference',
    prefPace: 'Pace (min/km or min/mi)',
    prefSpeed: 'Speed (km/h or mph)',
    accentColorLabel: 'Accent Color',
    shareAppDesc: 'Share this running pace calculator with friends or running groups.',
    shareAppBtn: 'Share PaceFlow app',
    shareAppCopied: 'PaceFlow link copied to clipboard!',

    // Install Modal
    installModalTitle: 'Add to Home Screen',
    installModalSubtitle: 'Install PaceFlow as a native app',
    benefitFast: '⚡ Fast',
    benefitFastDesc: '1-tap access',
    benefitOffline: '📶 Offline',
    benefitOfflineDesc: 'Works everywhere',
    benefitStorage: '💾 Local',
    benefitStorageDesc: 'Securely saved',
    installNowBtn: 'Install now',
    closeBtn: 'Close',

    // Onboarding / Welcome Modal
    onboardingTitle: 'Welcome to PaceFlow',
    onboardingSubtitle: 'Set your running preferences',
    onboardingNotice: 'You can adjust these settings at any time via the gear icon in the top bar.',
    onboardingStartBtn: 'Get Started',
    onboardingStepUnits: 'Choose your default unit',
    onboardingStepPaceOrSpeed: 'Default display (Pace vs Speed)',
    onboardingStepLanguage: 'Choose your language',
    onboardingStepTheme: 'Choose your theme',
    // Voorheen inline in componenten
    uiCalculateTime: 'Calculate Time',
    uiCalculateSpeed: 'Calculate Speed',
    uiCalculatePace: 'Calculate Pace',
    uiSpeed: 'Speed',
    uiCalculateDistance: 'Calculate Distance',
    uiFollowTheInstructionsBelow: 'Follow the instructions below',
    uiInstructionsForIphoneIpad: '🍎 Instructions for iPhone & iPad',
    uiInstructionsForAndroidDesktop: '🤖 Instructions for Android & Desktop',
    uiTapTheShareIconAt: 'Tap the Share icon at the bottom of Safari',
    uiScrollDownInTheMenu: 'Scroll down in the menu and tap \'Add to Home Screen\'',
    uiTapAddInTheTop: 'Tap \'Add\' in the top right. PaceFlow will appear on your home screen!',
    uiTapTheBrowserMenuThe: 'Tap the browser menu (the 3 dots ⋮) in Chrome or Edge.',
    uiChooseInstallAppOrAdd: 'Choose \'Install app\' or \'Add to Home screen\'.',
    uiConfirmInstallationAndLaunchPaceflow: 'Confirm installation and launch PaceFlow directly from your home screen.',
    uiMorningRun: 'Morning Run',
    uiRunningSession: 'Running Session',
    uiVeryTough: 'Very tough',
    uiFair: 'Fair',
    uiGood: 'Good',
    uiGreat: 'Great',
    uiPersonalRecord: 'Personal Record',
    uiHrsMinSec: 'hrs:min:sec',
    uiKmH: 'km/h',
    uiHrs: 'Hrs',
    uiMin: 'Min',
    uiSec: 'Sec',
    uiValidLogbookImported: 'Valid logbook imported',
    uiMergeWithExistingRuns: 'Merge with existing runs',
    uiOverwriteAllExistingRuns: 'Overwrite all existing runs',
    uiRun: 'Run',
    uiPaceflowRunningPaceCalculation: 'PaceFlow - Running Pace Calculation',
    uiPaceflowInstalled: 'PaceFlow Installed',
    uiRunningFromYourHomeScreen: 'Running from your home screen. Works 100% offline.',
    uiInstallPaceflow: 'Install PaceFlow',
    uiAddToHomeScreenFor: 'Add to home screen for 1-tap access and instant offline use.',
    uiAddToHomeScreen: 'Add to Home Screen',
    uiIosSafariTap: 'iOS Safari: Tap ',
    uiShare: '‘Share’',
    uiAddToHomeScreen2: '‘Add to Home Screen’',
    uiEnglish: 'English',
    uiKilometersKm: 'Kilometers (km)',
    uiMilesMi: 'Miles (mi)',
    uiTotal: 'Total',
    uiKilometer: 'Kilometer',
    uiSplitTimes: 'Split Times',
    uiTargetTimeBasedOnDistance: 'Target time based on distance & pace',
    uiHrMinSec: 'hr : min : sec',
    uiTxt: '@',
    uiRequiredPaceBasedOnDistance: 'Required pace based on distance & time',
    uiIn: 'in',
    uiDistanceBasedOnTimePace: 'Distance based on time & pace',
    importSchemaError: 'The JSON file does not match the valid PaceFlow log schema.',
    importInvalidJson: 'Invalid JSON file. Please check the file structure.',
    importFound: '{count} runs found in JSON file.',
    importChoice: 'Do you want to merge these runs with your current logbook or overwrite all existing logs?',
    pwaBrowserSupport: 'Works in Chrome, Edge & Safari • 100% offline',
    shareRunText: '🏃 PaceFlow Run: {distance} {distanceUnit} in {time} (Pace: {pace}{paceUnit}, {speed} {speedUnit})',
    shareAppText: '🏃 PaceFlow – Find Your Pace, Perfect Your Flow.\nCalculate running pace, target times & splits easily! 100% free and offline.',
    stratCustom: 'Custom',
    printBand: 'Print wristband',
    stratCustomDesc: 'Choose how much faster your second half gets.',
    customPctLabel: 'Negative split: {pct}% faster at the end',
    slowStartLabel: 'Easier first split',
    slowStartOff: 'Off',
    perfOpenTitle: 'Predictions & training zones',
    perfOpenDesc: 'See what you can run at other distances and which paces to train at.',
    perfTitle: 'Performance',
    perfSubtitle: 'Predictions and training paces',
    perfTabPredict: 'Predict',
    perfTabZones: 'Zones',
    perfTabTools: 'Tools',
    perfReference: 'Based on',
    perfRefCurrent: 'Current calculation',
    perfRefBest: 'Best from log',
    perfRefNone: 'Save a run in your log to use it as a reference.',
    perfIn: 'in',
    perfVdot: 'Fitness index (VDOT)',
    perfTooShort: 'Pick a distance and time of at least 3 minutes and at most 8 hours.',
    perfPredictNote: 'Estimate using Riegel. The further a distance is from your reference, the less certain it is.',
    race10Miles: '10 miles',
    raceHalf: 'Half marathon',
    raceMarathon: 'Marathon',
    zoneEasy: 'Easy',
    zoneEasyDesc: 'Long runs, recovery and base building',
    zoneMarathon: 'Marathon',
    zoneMarathonDesc: 'Your marathon race-day pace',
    zoneNameThreshold: 'Threshold',
    zoneThresholdDesc: 'Comfortably hard, tempo runs',
    zoneNameInterval: 'Interval',
    zoneIntervalDesc: 'Hard, blocks of 3 to 5 minutes',
    zoneRepetition: 'Repetition',
    zoneRepetitionDesc: 'Fast and short, with plenty of rest',
    zonesNote: 'Training paces after Daniels, calculated from your fitness index.',
    toolsWeather: 'Weather',
    toolsWeatherDesc: 'Heat slows you down. See how to adjust your pace.',
    toolsTemp: 'Temperature (°C)',
    toolsHumidity: 'Humidity (%)',
    toolsAdjusted: 'Adjusted pace',
    toolsSlowdown: 'About {pct}% slower',
    toolsNoSlowdown: 'No adjustment needed',
    toolsTreadmill: 'Treadmill',
    toolsTreadmillDesc: 'Convert treadmill speed to pace.',
    toolsSpeed: 'Speed',
    toolsCurrentPaceIs: 'Your current pace is',
    toolsTrack: 'Track',
    toolsTrackDesc: 'Times per distance at your current pace.',
    insightsTitle: 'Your progress',
    insightStreak: 'Week streak',
    insightStreakUnit: 'weeks',
    insightTrend: 'Pace trend',
    insightTrendFaster: '{sec} s/km faster',
    insightTrendSlower: '{sec} s/km slower',
    insightTrendSame: 'Unchanged',
    insightTrendNeed: 'Shown from 6 runs',
    insightWeekly: 'Kilometres per week',
    insightWeeklyLast12: 'The last 12 weeks',
    insightNow: 'Now',
    weekOf: 'Week of {date}',
    insightRecords: 'Personal records',
    insightRecordsNone: 'Run a standard distance, such as 5 or 10 km, to set a record.',
    insightFeeling: 'Feeling and pace',
    insightFeelingDesc: 'Average pace per feeling',
    goalTitle: 'Race goal',
    goalEmpty: 'Set a goal to count down and see whether you are on track.',
    goalSet: 'Set a goal',
    goalEdit: 'Edit goal',
    goalDelete: 'Delete goal',
    goalRace: 'Distance',
    goalTargetTime: 'Target time',
    goalDate: 'Race day',
    goalSave: 'Save',
    goalInvalid: 'Check the distance, target time and race day.',
    goalDaysLeft: '{days} days to go',
    goalOneDay: '1 day to go',
    goalToday: 'Race day is today',
    goalPast: 'Race day has passed',
    goalRequiredPace: 'Required pace',
    goalPredicted: 'Predicted from your best run',
    goalStatusAhead: 'Ahead of schedule',
    goalStatusOn: 'On track',
    goalStatusBehind: 'Still {time} too slow',
    goalStatusUnknown: 'Save a run to see whether you are on track',
    editRunTitle: 'Edit run',
    editRunBtn: 'Edit',
    formDate: 'Date',
    exportCsv: 'Export as CSV',
    runDeletedToast: 'Run deleted',
    runRestoredToast: 'Run restored',
    runUpdatedToast: 'Run updated',
    undoBtn: 'Undo',
    recordBadge: '{distance} record',
    newRecordToast: 'New {distance} record!',
  },
} as const;

export type TranslationKey = keyof typeof TRANSLATIONS.nl;

/** Zoals t(), maar vult {naam}-plaatsvervangers in. */
export function tf(lang: Language, key: TranslationKey, vars: Record<string, string | number>): string {
  return t(lang, key).replace(/\{(\w+)\}/g, (_m, name) => String(vars[name] ?? `{${name}}`));
}

export function t(lang: Language, key: TranslationKey): string {
  return TRANSLATIONS[lang]?.[key] || TRANSLATIONS.nl[key] || '';
}
